exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "::-webkit-scrollbar{width:13px !important;height:0}::-webkit-scrollbar-thumb{background:#d3d4d6;border-radius:0px}.right_process::-webkit-scrollbar{width:0px !important;height:0}.right_process::-webkit-scrollbar-thumb{background:#d3d4d6;border-radius:0px}.left_process::-webkit-scrollbar{width:0px !important;height:0}.left_process::-webkit-scrollbar-thumb{background:#d3d4d6;border-radius:0px}", ""]);

// exports
